<template>
  <b-container id="wrapper_sidebar">
      <b-row class="w-100">
        <b-col>
            <div id="wrapper_title" class="mt-4 mb-0">
                <b-row class="w-100">
                    <template v-if="this.info.data.distribution.length > 0
                                        && this.info.data.documentInfo.status_stop_id != 3
                                        && this.info.data.documentInfo.status_stop_id != 4
                                        && this.info.data.documentInfo.status_stop_id != 8
                                        && this.info.data.documentInfo.status_stop_id != 6
                                        && this.info.data.documentInfo.status_stop_id != 9
                                        && this.info.data.documentInfo.status_stop_id != 13
                                        && this.info.data.documentInfo.status_stop_id != 14
                                        && this.info.data.distribution[0].arrival != null">
                        <b-col sm="5" cols="p-0">
                            <div v-if="info.data.documentInfo.display_social_name != 0">
                                <p class="font-weight-bold text-uppercase text-left topbar_text" id="document_number">{{info.data.documentInfo.name}}</p>
                            </div>
                        </b-col>
                        <b-col class="text-center" sm="4" cols="p-0">
                            <h4 style="margin-bottom: 0px;"><b-icon class="mr-2" icon="clock"></b-icon>{{ translationData.arrival }}</h4>
                            <h4 class="font-weight-bold" style="color: #4eca8a;">{{this.info.data.distribution[0].arrival | moment("utc","DD/MM/YYYY HH:mm")}}</h4>
                        </b-col>
                        <b-col sm="3" cols="p-0">
                            <p class="font-weight-bold text-md-right topbar_text mb-1" id="document_name">{{info.data.documentInfo.type}} {{info.data.documentInfo.number}}</p>
                            <p class="w-100 text-right" v-b-toggle.collapse-1 v-if="this.showDetails == true" v-on:click="toggleDetails">{{ translationData.hideDetails }}<b-icon-chevron-up></b-icon-chevron-up></p>
                            <p v-else class="w-100 text-right" v-b-toggle.collapse-1 v-on:click="toggleDetails">{{ translationData.showDetails }}<b-icon-chevron-down></b-icon-chevron-down></p>  
                        </b-col>
                    </template>
                    <template v-else>
                        <b-col sm="8" cols="p-0">
                            <div v-if="info.data.documentInfo.display_social_name != 0">
                                <p class="font-weight-bold text-uppercase text-left topbar_text" id="document_number">{{info.data.documentInfo.name}}</p>
                            </div>
                        </b-col>
                        <b-col sm="4" cols="p-0">
                            <p class="font-weight-bold text-md-right topbar_text mb-1" id="document_name">{{info.data.documentInfo.type}} {{info.data.documentInfo.number}}</p>
                            <p class="w-100 text-right" v-b-toggle.collapse-1 v-if="this.showDetails == true" v-on:click="toggleDetails">{{ translationData.hideDetails }} <b-icon-chevron-up></b-icon-chevron-up></p>
                            <p v-else class="w-100 text-right" v-b-toggle.collapse-1 v-on:click="toggleDetails">{{ translationData.showDetails }}<b-icon-chevron-down></b-icon-chevron-down></p>  
                        </b-col>
                    </template>
                </b-row>
                <b-row class="w-100">     
                    <b-collapse id="collapse-1" class="w-100">
                        <b-card bg-variant="white" text-variant="dark" :title="translationData.details" class="card-roadmap w-100">
                            <b-col class="w-100">
                              <b-row class="w-100">  
                                <b-col class="w-50"> 
                                    <div v-if="info.data.documentInfo.display_address != 0">
                                        <label>{{ translationData.street }}</label>
                                        <p>{{info.data.documentInfo.street}}</p>
                                        <label>{{ translationData.district }}</label>
                                        <p>{{info.data.documentInfo.district}}</p>
                                        <label>{{ translationData.city }}</label>
                                        <p>{{info.data.documentInfo.city}} - {{info.data.documentInfo.state}}</p>
                                        <label>{{ translationData.postalCode }}</label>
                                        <p>{{info.data.documentInfo.cep}}</p>
                                    </div>
                                </b-col>
                                <b-col class="w-50"> 
                                    <div v-if="info.data.documentInfo.display_emission != 0">
                                        <label>{{ translationData.emission }}</label>   
                                        <p v-if="info.data.documentInfo.display_time != 0">{{ info.data.documentInfo.created | moment("utc","DD/MM/YYYY HH:mm") }}</p>
                                        <p v-else>{{ info.data.documentInfo.emission | moment("utc","DD/MM/YYYY") }}</p>
                                    </div>
                                    <div v-if="info.data.documentInfo.display_sla != 0">
                                        <label>Prazo de entrega</label>
                                        <p>{{info.data.documentInfo.end_date | moment("utc","DD/MM/YYYY")}}</p>
                                    </div>
                                    <div v-if="info.data.documentInfo.display_value != 0">
                                        <label>{{ translationData.value }}</label>
                                        <p>R${{info.data.documentInfo.value}}</p>
                                    </div>
                                </b-col>
                              </b-row>
                              <div v-if="info.data.documentInfo.display_info != 0">
                                <b-row class="w-100">
                                  <b-col class="w-100 mt-3"> 
                                      <label>Itens</label>
                                      <template v-for="item in this.info.data.details">
                                          <p>{{ item.amount }} {{ item.uom }} - {{ item.description }}</p>
                                      </template>
                                  </b-col>
                                </b-row>
                              </div>
                            </b-col>
                        </b-card>
                    </b-collapse>
                </b-row>
            </div>
        </b-col>
      </b-row>
      <template v-if="this.info.data.distribution.length > 0">
        <b-row class="w-100" v-if="this.info.data.distribution[0].status_route_id != 6 
                                    && this.info.data.documentInfo.status_stop_id != 3 
                                    && this.info.data.documentInfo.status_stop_id != 4
                                    && this.info.data.documentInfo.status_stop_id != 8">
            <b-col>
                <RouteTracking v-bind:distribution="this.info.data.distribution"/>
            </b-col>
        </b-row>
      </template>
      <b-row class="w-100">
          <b-col>
            <Roadmap v-bind:data="this.info.data"/> 
        </b-col>
      </b-row>
  </b-container>
</template>

<script>
import Roadmap from './sidebar/Roadmap.vue'
import RouteTracking from './sidebar/RouteTracking.vue'
import Details from './sidebar/Details.vue'
import TranslationEs from '../locale/esp/translation_esp.json'
import TranslationPt from '../locale/pt/translation_pt.json'

export default {
    name: 'Sidebar',
    props: ['info'],
    data() {
        return {
            showDetails: false,
            language: null,
            translationData: {}
        }
    },
  created() {
    const url = window.location.href;
    const langParam = 'lang=';
    const langIndex = url.indexOf(langParam);
    console.log('url: ', url);
    console.log('langIndex: ', langIndex);

    if (langIndex !== -1) {
      const langValue = url.substring(langIndex + langParam.length);
      this.language = langValue;
      console.log('this language: ', this.language);
    } else {
      // Se o parâmetro "lang" não for encontrado, defina um idioma padrão (por exemplo, português)
      this.language = 'pt';
    }

    if (this.language === 'esp' && TranslationEs) {
      this.translationData = TranslationEs;
      console.log('Translations (esp):', this.translationData);
    } else {
      this.translationData = TranslationPt;
      console.log('Translations (pt):', this.translationData);
    }
  },
    components: {
        Roadmap,
        RouteTracking,
        Details
    },
    methods: {
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
    }
  }
}
</script>

<style>
#wrapper_sidebar{
    background: #ffffff;
    height: 100%;
    overflow: hidden;
    border-right: 1px solid #c5c5c5;
    border-left: 1px solid #c5c5c5;
}

.title{
    font-size: 20px;
    margin: 20px 0 0 5px;
}
</style>

<style scoped>
.row{
    margin: 0 !important;
}

.popover_info{
    line-height: 10px;
}

.topbar_text{
    font-size: 1.6em;
}

#collapse-1 label{
    line-height: 10px;
}

#collapse-1 p{
    font-size: 16px;
    line-height: 15px;
    font-weight: bold;
    margin-bottom: 5px;
}
</style>